<template>
  <page
    :name="$t('Opportunità')"
    :description="$t('Qui trovi la lista di tutte le possibili opportunità e leads che ti abbiamo segnalato')"
    :state="opportunitiesState"
  >
    <pf-page-section>
      <project-list v-if="opportunities.length" variant="opportunity" :projects="opportunities" @feedback="opportunitiesState.update()" />

      <pf-empty-state v-else>
        <pf-empty-state-header :title="$t('Al momento non ci sono opportunità o lead.')">
        </pf-empty-state-header>
        <pf-empty-state-body>
          {{ $t('Se non l\'hai ancora fatto compila le tue skill e abilità nella sezione "Skill" e aiutaci a inviarti segnalazioni e possibili nuovi clienti') }}
        </pf-empty-state-body>
        <pf-empty-state-footer>
          <pf-empty-state-actions>
            <granted-link :to="{ name: 'my_skills' }" type="primary">{{ $t('Vai alle Skill') }}</granted-link>
          </pf-empty-state-actions>
        </pf-empty-state-footer>
      </pf-empty-state>
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import { asyncComputedList } from '@common/asyncComputed';
import { OpportunityResource } from '@/resources';
import ProjectList from '@/components/project-list.vue';
import GrantedLink from '@/components/granted-link.vue';

const { state: opportunitiesState, result: opportunities } = asyncComputedList(() => new OpportunityResource().get());
</script>
